export var defaultJsonSerializer = JSON;